import { styled, css } from "styled-components";
import media from "../../../../styles/mediaQueries";
export const StyledLanguageSelector = styled.div `
  padding: 0 14px;
  margin-top: auto;
  position: relative;
  ${media.up("medium") `
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
  `};
  @media (max-height: 630px) and (min-width: 992px) {
    margin-top: auto;
    position: relative;
    padding-bottom: 20px;
  }
  @media (max-height: 770px) and (min-width: 1200px) {
    margin-top: 25px;
    position: relative;
    padding-bottom: 20px;
  }
  @media (max-height: 600px) and (min-width: 1200px) {
    padding-bottom: 60px;
  }
  @media (max-height: 770px) and (max-width: 1450px) and (min-width: 1200px) {
    margin-top: auto;
    position: absolute;
    padding-bottom: 0;
  }
`;
const btnNoStyle = css `
  border: none;
  outline: 0;
  background: 0 0;
  -moz-appearance: none;
  appearance: none;
  line-height: 1;
  line-height: initial;
  padding: 0;
  padding: initial;
  margin: 0;
  margin: initial;
`;
export const DropdownToggle = styled.a `
  ${btnNoStyle};
  position: relative;
  color: "black";
  font-size: 16px;
  font-weight: 100;
  ${({ noLeftPadding }) => noLeftPadding
    ? css `
          padding: 13px 0 10px 0;
        `
    : css `
          padding: 13px 0 10px 44px;
        `};
  width: 100%;
  display: block;
  text-decoration: none;

  > span {
    white-space: nowrap;
    margin-left: 5px;
    font-weight: 400;
    > span {
      margin-left: 4px;
    }

    > svg {
      left: 17px;
      top: 15px;
      position: absolute;
      width: 20px;
      height: auto;
      border: 0;
      vertical-align: middle;
      ${media.down("belowMedium") `
        left: 7px;
      `}

      ${media.only("medium", "belowLarge") `
        left: 7px;
      `}

      ${media.only("large", "xlarge") `
        top: 16px;
        left: 3px;
      `}
    }
  }

  ${media.up("large") `
    padding: 15px 0 10px 0px;
  `}
  ${media.only("medium", "belowLarge") `
    font-size: 14px;
    padding: 13px 0 10px 0px;
  `}
  ${media.only("large", "xlarge") `
    padding: 15px 0 10px 0px;
    font-size: 14px;
  `}
`;
export const DropdownMenu = styled.ul `
  position: absolute;
  ${({ dropBelow }) => !dropBelow
    ? css `
          bottom: 100%;
        `
    : css `
          bottom: unset;
        `};
  z-index: 1000;
  float: left;
  min-width: 160px;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;

  top: auto;
  border-radius: 0;
  margin: 0;
  padding: 7px 0;
  list-style: none;
  left: 10px;
  ${({ dropDownWidth }) => dropDownWidth
    ? css `
          width: ${dropDownWidth};
        `
    : css `
          width: 90%;
        `};
`;
export const DropdownMenuItem = styled.li `
  margin: 0;
  padding: 0;
  button {
    background: transparent;
    border: 0;
    appearance: none;
    width: 100%;
    display: flex;
    cursor: pointer;
    line-height: 1.428571429;
    white-space: nowrap;
    transition: all 0.3s ease;
    padding: 8px 15px 10px;
    font-size: 18px;
    color: #333;
    font-weight: 400;
    text-decoration: none;
    clear: both;

    ${media.up("medium") `
      font-size: 15px;
    `}

    &:hover {
      background: #ff0033;
    }
    > svg {
      width: 32px;
      height: auto;
      padding-right: 10px;
    }
    > span {
      position: relative;
      top: 2px;
    }
  }
`;
//# sourceMappingURL=style.js.map